import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Button } from "@mui/material";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import { Box } from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import { DataGrid } from "@mui/x-data-grid";
import { Modal, ModalClose, Sheet, Typography } from "@mui/joy";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function QuadrantList() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [quadrants, setQuadrants] = useState([]);
  const [callApi, setCallApi] = useState(false);
  const [warning, setWarning] = useState({ text: "", type: "" });
  const [selectedId, setSelectedId] = useState(null);
  const [openWarning, setOpenWarning] = useState(false);

  const fetchQuadrants = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}common/quadrants`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setQuadrants(res.data);
    } catch {
      alert("Session expired");
      localStorage.clear();
      navigate("/login");
    }
  };

  const deleteQuadrant = async (id) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BASE_URL}common/quadrants/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCallApi((prev) => !prev);
    } catch {
      alert("Failed to delete quadrant");
    }
  };

  useEffect(() => {
    fetchQuadrants();
  }, [callApi]);

  const columns = [
    {
      field: "s_no",
      headerName: "S.no",
      width: 80,
      sortable: true
    },
    {
      field: "tab",
      headerName: "Tab",
      flex: 1,
      sortable: true
    },
    {
      field: "index",
      headerName: "Index",
      flex: 1,
      sortable: true
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: true
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "0.5rem" }}>
          {/* Edit */}
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => navigate(`/edit-quadrant/${params.row.id}`)}
          >
            <i className="fas fa-edit" />
          </Button>

          {/* Delete */}
          <Button
            size="small"
            variant="contained"
            color="error"
            onClick={() => {
              setSelectedId(params.row.id);
              setWarning({ text: "Delete this quadrant?", type: "delete" });
              setOpenWarning(true);
            }}
          >
            <i className="fas fa-trash" />
          </Button>
        </div>
      ),
    },
  ];

  const rows = quadrants.map((q, idx) => ({
    id: q._id,
    s_no: idx + 1,
    tab: q.tab?.name || "—",
    index: q.index,
    name: q.name,
  }));

  return (
    <PageLayout>
      <Grid container spacing={3}>
        <Grid size={12}
          xl={12}
          className="d-flex justify-content-between align-items-center"
        >
          <Breadcrumb title="Quadrant List" />
          <Link to="/add-quadrant">
            <Button variant="contained" color="primary">Add Quadrant</Button>
          </Link>
        </Grid>

        <Grid size={12} xl={12} className="mt-3">
          <Box className="mc-card">
            <CardHeader title="Quadrant List" />
            <div style={{ height: 600, width: "100%", marginTop: "1rem" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pageSizeOptions={[5, 10, 25, 50]}
                disableRowSelectionOnClick
              />
            </div>
          </Box>
        </Grid>

        {/* Delete Confirmation */}
        <Modal
          open={openWarning}
          onClose={() => setOpenWarning(false)}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              width: "30%",
              p: 3,
              borderRadius: "md",
              boxShadow: "lg",
              bgcolor: "#fff",
            }}
          >
            <ModalClose sx={{ top: 8, right: 8 }} />
            <Typography fontSize="1.25em" mb={3}>
              {warning.text}
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "2rem",
              }}
            >
              <Button
                variant="contained"
                color="success"
                style={{ width: "8rem" }}
                onClick={() => {
                  deleteQuadrant(selectedId);
                  setOpenWarning(false);
                }}
              >
                Yes
              </Button>
              <Button
                variant="contained"
                color="error"
                style={{ width: "8rem" }}
                onClick={() => setOpenWarning(false)}
              >
                No
              </Button>
            </div>
          </Sheet>
        </Modal>
      </Grid>
    </PageLayout>
  );
}
